import type { TableHead } from '@/types/table/table-head'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function dataToTableCell(head: TableHead, value: any) {
  return head.toText ? head.toText(value) : value
}
